// @ts-nocheck

import { map } from 'lodash';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled, { css } from 'styled-components';

import routes from '../../routes/grids';
import { MenuStyle } from '../../styled-components/desktop/menu';

const StyledLeftColumn = styled(MenuStyle)`
  width: 350px;
  margin-right: 10px;

  ${({ $isGridHistory, theme }) =>
    $isGridHistory
      ? css`
          width: 220px;
        `
      : css`
          @media screen and (min-width: ${theme.breakpoints.lg}px) and (max-width: ${theme.breakpoints.xl - 1}px) {
            margin-right: 53px;
          }

          @media screen and (min-width: ${theme.breakpoints.xl}px) {
            margin-right: 120px;
          }
        `}
`;
type DesktopGridsLayoutLeftColumnProps = {
  isGridHistory: boolean;
};

/**
 * Display the left column for the grids section
 *
 * @param  {boolean} isGridHistory Check if we are on grid history (the history detail is excluded)
 * @return {ReactNode}             A styled component with all the necessary routes
 */
const DesktopGridsLayoutLeftColumn = ({ isGridHistory }: DesktopGridsLayoutLeftColumnProps) => {
  return (
    <StyledLeftColumn $isGridHistory={isGridHistory}>
      <Switch>
        {map(routes, ({ pattern, Menu, exact }, key) => (
          <Route key={key} path={pattern} exact={exact}>
            <Menu />
          </Route>
        ))}
      </Switch>
    </StyledLeftColumn>
  );
};

export default DesktopGridsLayoutLeftColumn;
